import React, { Component } from 'react';
import { matchPath } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { analyzeParams, planAnalyzeInfo } from '../../../actions/analyze';
import { clearMapData, getMapEgList, mapLoaded, mapUnload, mapPosition } from '../../../actions/map';
import { setLoadHistoryShowModal } from '../../../actions/load';
import { getGeoRegionList } from '../../../actions/geo';
import { getDistanceList } from "../../../actions/distance";
import { getEGReportIssue } from "../../../actions/equipment-group";
import { toastSnackbar } from '../../../actions/toast';
import { BarLoader } from '../../widgets';
import { connectSocket } from '../../../actions/socket';
import { isFarmView, isRangeChanged, usePermission } from '../../../helpers/common';
import MapView from './MapView';
import { NO_EG_FOUND } from '../../../constants/messages';
import { getDrawingInstance } from '../geo/DrawingControl';

class Map extends Component {
    constructor() {
        super();
        this.bindMapEgList = this.bindMapEgList.bind(this);
        this.bindGeoShapes = this.bindGeoShapes.bind(this);
        this.state = {
            isShowMap: false
        }
        this.drawingTools = null;
    }

    componentDidMount() {
        if (!window.socketClient) this.props.actions.connectSocket();
        this.bindMapEgList();
        this.bindGeoShapes();
        this.bindAnalyzeInfo();
        this.viewMap();
    }

    viewMap = () => {
        const allow = usePermission();
        const isAllowMap = allow("map", "view");
        this.setState({ isShowMap: isAllowMap });
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            const selectedRegionIds = this.props.geoRegionList.map(it => it.geo_region_uuid);
            this.drawingTools.showShapeGroups(selectedRegionIds || [], true);
        }
        if (prevProps.location.pathname !== this.props.location.pathname &&
            !isFarmView(this.props.analyze.view)) this.bindAnalyzeInfo();

        if (prevProps.isNotFound !== this.props.isNotFound &&
            this.props.isNotFound && !this.props.isFetching && !this.props.isForceClearEG)
            this.props.actions.toastSnackbar(NO_EG_FOUND.message);

        if (prevProps.search.rangeId !== this.props.search.rangeId) this.bindGeoShapes();

        if (prevProps.selectedPlanType !== this.props.selectedPlanType) this.bindMapEgList(true);

        if (prevProps.refreshCount !== this.props.refreshCount) this.bindMapEgList();
        else if (prevProps.match.params.farmId !== this.props.match.params.farmId) {
            this.bindGeoShapes();
            this.bindMapEgList(true);
        }
        else if (this.props.search.enable && isRangeChanged(prevProps.search, this.props.search)) {
            this.bindMapEgList();
        }
    }

    bindMapEgList(isClearMap) {
        if (isClearMap) this.props.actions.clearMapData();
        const { farmId } = this.props.match.params;
        const selectedPlanType = this.props.selectedPlanType;
        this.props.actions.getMapEgList({ farmId, selectedPlanType });
        this.props.actions.getEGReportIssue(farmId)
    }

    bindGeoShapes() {
        const { farmId } = this.props.match.params;
        const range = this.props.search.custom;
        this.props.actions.getGeoRegionList(farmId, true, range);
        if(farmId !== 'dc4e522a-ac96-11ea-9459-42010a8a0046') this.props.actions.getDistanceList(farmId)
    }

    bindAnalyzeInfo() {
        const match = matchPath(this.props.location.pathname,
            { path: `/home/farm/:farmId/map`, exact: true, strict: false });
        if (!match) return;

        const { farmId } = match.params;
        this.props.actions.planAnalyzeInfo(farmId);
    }

    componentWillUnmount() {
        this.props.actions.clearMapData(true);
    }

    render() {
        const { farmId } = this.props.match.params;
        const { loadHistoryParams: { crewId, egId } } = this.props;
        this.drawingTools = getDrawingInstance();
        return <>
            {this.props.isFetching && <BarLoader />}
            {this.state.isShowMap && <MapView
                farmId={farmId}
                crewId={crewId}
                egId={egId}
                history={this.props.history}
                position={this.props.position}
                setLoadHistoryShowModal={() => this.props.actions.setLoadHistoryShowModal(true)}
                selectedPlanType={this.props.selectedPlanType}
                isAllPlan={this.props.isAllPlan}
                analyze={{
                    show: this.props.analyze.show,
                    disabled: this.props.analyze.disabled,
                    title: this.props.analyze.title,
                    isTruck: this.props.analyze.isTruck,
                    categeryId: this.props.analyze.categeryId
                }}
                onLoaded={this.props.actions.mapLoaded}
                onUnload={this.props.actions.mapUnload}
                onPosition={(position, farmId) => this.props.actions.mapPosition({ position, farmId })}
            />}
        </>;
    }
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        connectSocket, analyzeParams, planAnalyzeInfo, getMapEgList,
        mapLoaded, mapUnload, mapPosition, clearMapData, toastSnackbar,
        getGeoRegionList, setLoadHistoryShowModal, getEGReportIssue, getDistanceList
    }, dispatch)
});

const mapStateToProps = state => ({
    isFetching: state.map.isFetching,
    isNotFound: state.map.isNotFound,
    isForceClearEG: (Array.isArray(state.map.filters.egIds) && state.map.filters.egIds.length === 0),
    refreshCount: state.map.refreshCount,
    position: state.map.positionById[state.farm.currentFarm.farm_uuid],
    selectedPlanType: state.plan.selectedPlanType,
    isAllPlan: state.plan.isSelectAllPlan,
    analyze: {
        show: state.analyze.analyzeParams.show,
        disabled: state.analyze.analyzeParams.disabled,
        view: state.analyze.analyzeParams.view,
        title: state.analyze.analyzeParams.title,
        isTruck: state.analyze.analyzeParams.isTruck,
        categeryId: state.analyze.analyzeParams.categeryId
    },
    loadHistoryParams: {
        crewId: state.load.loadHistory.params.crewId,
        egId: state.load.loadHistory.params.egId
    },
    search: {
        rangeId: state.analyze.searchParams.rangeId,
        range: state.analyze.searchParams.range,
        customRange: state.analyze.searchParams.customRange,
        custom: state.analyze.searchParams.custom,
        enable: state.analyze.searchParams.enable
    },
    geoRegionList: state.geo.regionsList,
    selectedCrewId: state.crew.selectedCrew,
    selectedCrewV1: state.crewKanban.crews
});

export default connect(mapStateToProps, mapDispatchToProps)(Map);